// export default {
//     apiUrl : "http://127.0.0.1:4982"
// }
// export default {
//     apiUrl : "https://svr1.spinbonanza.top"
// }
export default {
    apiUrl : "https://spinbonanza-da2c516cbddf.herokuapp.com"
}